import router from './router'
import store from './store'
import ngConfig from "@/config"
import { getToken } from '@/utils/auth'
import { setTitle } from '@/utils/util'
const whiteList = ['/step','/login','/step/step1','/step/step2','/step/step3']

router.beforeEach((to, from, next) => {
  if (getToken('msid')) {
    const browserHeaderTitle = to.name
    store.commit('SET_BROWSERHEADERTITLE', {
      browserHeaderTitle: browserHeaderTitle
    })
    if(whiteList.indexOf(to.path) === -1&&store.getters.menus.length == 0){
      store.dispatch('GetDesktopMenus')
    }
      next()

  } else {
    const browserHeaderTitle = to.name
    store.commit('SET_BROWSERHEADERTITLE', {
      browserHeaderTitle: browserHeaderTitle
    })
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})
router.afterEach(() => {
  setTimeout(() => {
    const browserHeaderTitle = store.getters.browserHeaderTitle
    setTitle(browserHeaderTitle)
  }, 0)
})



// WEBPACK FOOTER //
// ./src/modules/desktop/permission.js